// Import necessary libraries/components/pages
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import './App.scss';
import AboutPage from "./pages/AboutPage";
import PortfolioPage from "./pages/PortfolioPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import ContactPage from "./pages/ContactPage";
import { ReactComponent as Signature } from './images/signature.svg';

function usePageTitle(title) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}

function Home() {
  usePageTitle('Chad Espelage - React Portfolio Site');
  return (
    <><div className="Hero homepage">
      <div className="text-block">
        <p>Welcome to the Professional Portfolio site of</p>
        <Signature />
        <p>Senior Salesforce Commerce Cloud Developer</p>
        <p>with expertise in pixel-perfect front-end development,</p>
        <p>seamlessly Bridging the Gap Between Design & Back-End functionality</p>
        <AnimatedButton />
      </div>
    </div>
    <div>
      <Footer />
    </div></>
  );
}

function About() {
  usePageTitle('Chad Espelage - About');
  return (
    <>
    <AboutPage />
    </>
  );
}

function Portfolio() {
  usePageTitle('Chad Espelage - Portfolio');
  return (
    <>
    <PortfolioPage />
    </>
  );
}

function Testimonials() {
  usePageTitle('Chad Espelage - Testimonials');
  return (
    <>
    <TestimonialsPage />
    </>
  );
}

function Contact() {
  usePageTitle('Chad Espelage - Contact');
  return (
    <div className="page-container">
      <h1>Contact</h1>
      <p>Feel free to reach out and connect</p>
      <ContactPage />
      <Footer />
    </div>
  );
}

function AnimatedButton() {
  return (
    <Link to="/about">
      <button className="animated-button">
        Learn More!
      </button>
    </Link>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <InnerApp />
    </Router>
  );
}

function InnerApp() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="App">
      <nav className="navbar">
        <button className="hamburger" onClick={() => setIsNavOpen(!isNavOpen)}>
          <div className={`animated-icon ${isNavOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
        <ul className={`nav-links ${isNavOpen ? 'open' : ''}`}>
          <li><Link to="/" className={location.pathname === "/" ? "active" : ""} onClick={() => setIsNavOpen(false)}>Home</Link></li>
          <li><Link to="/about" className={location.pathname === "/about" ? "active" : ""} onClick={() => setIsNavOpen(false)}>About</Link></li>
          <li><Link to="/portfolio" className={location.pathname === "/portfolio" ? "active" : ""} onClick={() => setIsNavOpen(false)}>Portfolio</Link></li>
          <li><Link to="/testimonials" className={location.pathname === "/testimonials" ? "active" : ""} onClick={() => setIsNavOpen(false)}>Testimonials</Link></li>
          <li><Link to="/contact" className={location.pathname === "/contact" ? "active" : ""} onClick={() => setIsNavOpen(false)}>Contact</Link></li>
        </ul>
      </nav>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </div>
  );
}

export default App;
